import React, { useState, useEffect } from "react";
import Combobox from "react-widgets/Combobox";
import "react-widgets/styles.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./barberUnavailability.css";
const BarberUnavailabilityModal = ({
  isOpen,
  onClose,
  mode,
  source,
  onSave,
  initialData, // { day: "Monday", startTime: "09:00", endTime: "17:00" }
}) => {
  const today = new Date().toISOString().split("T")[0];
  const [selectedFromDate, setSelectedFromDate] = useState(today);
  const [selectedToDate, setSelectedToDate] = useState(today);
  const [startTime, setStartTime] = useState("00:00");
  const [endTime, setEndTime] = useState("00:00");
  const [fullDay, setFullDay] = useState();
  const [reason, setReason] = useState("");

  // Load data when editing
  useEffect(() => {
    if (initialData) {
      console.log(initialData);
      setSelectedToDate(
        new Date(initialData.date).toLocaleDateString().split("T")[0] || "",
      );
      setStartTime(initialData.startTime || null);
      setEndTime(initialData.endTime || null);
      setFullDay(() =>
        initialData.endTime == initialData.startTime &&
        initialData.startTime == null
          ? true
          : false,
      );
      setReason(initialData.reason);
    } else {
      setSelectedFromDate(today);
      setSelectedToDate(today);
      setStartTime("00:00");
      setEndTime("00:00");
      setReason("");
      setFullDay(false);
    }
  }, [initialData, isOpen]);
  // Load data when editing
  useEffect(() => {
    if (fullDay) {
      setStartTime(null);
      setEndTime(null);
    } else {
      setStartTime("00:00");
      setEndTime("00:00");
    }
  }, [fullDay]);
  const generateTimeSlots = (intervalMinutes = 15) => {
    const times = [];
    for (let h = 0; h < 24; h++) {
      for (let m = 0; m < 60; m += intervalMinutes) {
        const hour = String(h).padStart(2, "0");
        const minute = String(m).padStart(2, "0");
        times.push(`${hour}:${minute}`);
      }
    }
    return times;
  };
  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (
      !selectedFromDate ||
      !selectedToDate ||
      (!startTime && !fullDay) ||
      (!endTime && !fullDay) ||
      !reason
    ) {
      alert("Please fill out all fields");
      return;
    }
    onSave({
      startTime,
      endTime,
      fullDay,
      selectedFromDate,
      selectedToDate,
      reason,
    });
    onClose();
  };

  return (
    <div className={`modal  ${isOpen ? "show" : ""}`} tabindex="-1">
      <div className="modal-dialog  modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              {source === "page"
                ? mode === "edit"
                  ? "Edit"
                  : "Add new un availability"
                : source === "calendar"
                  ? mode === "edit"
                    ? "Edit block time"
                    : "Block time"
                  : ""}
            </h5>
          </div>
          <div className="modal-body">
            <div className="row client-form">
              {mode === "add" && source === "page" && (
                <div className="col-6 form-control-container ">
                  <label
                    htmlFor="FromDate"
                    className="form-label form-control-label"
                  >
                    From Date
                  </label>
                  <input
                    type="date"
                    className="form-control form-input"
                    value={selectedFromDate}
                    onChange={(e) => setSelectedFromDate(e.target.value)}
                  />
                </div>
              )}
              {source === "page" && (
                <div
                  className={
                    mode === "add" && source === "page"
                      ? "col-6 form-control-container "
                      : "col-12 form-control-container "
                  }
                >
                  <label
                    htmlFor="ToDate"
                    className="form-label form-control-label"
                  >
                    {mode === "add" && source === "page" ? "To Date" : "Date"}
                  </label>
                  <input
                    type="date"
                    className="form-control form-input"
                    value={selectedToDate}
                    onChange={(e) => setSelectedToDate(e.target.value)}
                  />
                </div>
              )}

              {source === "calendar" && (
                <div className="col-12 form-control-container ">
                  <p className="col-12 unavailable-date d-flex flex-row ">
                    <div className="option-icon  unavailable-icon">
                      <i className="bi bi-lock-fill"></i>
                    </div>
                    <strong className="unavaialable-date-text">
                      {initialData.date}
                    </strong>
                  </p>
                </div>
              )}
              <div className="col-6 form-control-container ">
                <div className="form-check">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={fullDay}
                    onChange={(e) => setFullDay(!fullDay)}
                  />
                  <label className="form-check-label" for="flexCheckDefault">
                    Full Day {fullDay}
                  </label>
                </div>
              </div>
              {!fullDay && (
                <div className="row">
                  <div className="col-6 form-control-container">
                    <label
                      htmlFor="name"
                      className="form-label form-control-label"
                    >
                      Start
                    </label>
                    <Combobox
                      onChange={(value) => setStartTime(value)}
                      data={generateTimeSlots()}
                      value={startTime}
                      defaultValue={startTime}
                      containerClassName={" form-combobox"}
                    />
                  </div>
                  <div className="col-6 form-control-container">
                    <label
                      htmlFor="name"
                      className="form-label form-control-label"
                    >
                      End
                    </label>
                    <Combobox
                      onChange={(value) => setEndTime(value)}
                      data={generateTimeSlots()}
                      value={endTime}
                      defaultValue={endTime}
                      containerClassName={" form-combobox"}
                    />
                  </div>
                </div>
              )}
              <div className="col-12 form-control-container ">
                <label htmlFor="name" className="form-label form-control-label">
                  Reason
                </label>
                <input
                  type="text"
                  className="form-control form-input"
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                />
              </div>
            </div>
            <div className="d-flex justify-content-end modal-footer mt-4 mb-3">
              <button
                type="submit"
                className="btn btn-secondary me-2"
                onClick={() => onClose()}
              >
                Cancel
              </button>{" "}
              <button
                type="submit"
                className="btn btn-primary"
                onClick={(e) => handleSubmit(e)}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BarberUnavailabilityModal;
